import EcoSectionCard from 'eco-design/sections/eco-section-card';
import { getImgUrl } from '../../utils';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.SectionK');

    const item = {
        jp: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745379616935/K.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745379616748/K-h5.jpg',
        },
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744598719595/K.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744598719425/K-h5.jpg',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744685787039/K-gs.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744685786860/K-gs-h5.jpg',
        },
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722047710/UK.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722046669/APP-UK.jpg',
        },
        nl: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722047710/UK.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722046669/APP-UK.jpg',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722047710/UK.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722046669/APP-UK.jpg',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722047292/FR.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722046187/APP-FR.jpg',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722047543/IT.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722046375/APP-IT.jpg',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722047107/ES.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722046003/APP-ES.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722046858/DE.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722045776/APP-DE.jpg',
        },
        au: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722047710/UK.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722046669/APP-UK.jpg',
        },
    };

    return (
        <div className={styles.comp} id="SectionK">
            <EcoSectionCard theme="black" layout="center-left" label={t('label')} title={t('title')} desc={t('desc')} {...getImgUrl(item)} />
        </div>
    );
}
